import React from 'react';

import Icon from '../Icon/Icon';

const SpecialOffersIcon = (props) => {
    return (
        <Icon width='64' height='64' {...props}>
            <g stroke='#34303D' strokeWidth='2.667' fill='none' fillRule='evenodd'>
                <path
                    d='M19.611 15.944H41.2c1.036 0 1.977.6 2.416 1.538l1.857 3.973v28.986a4 4 0 0 1-4 4H19.333a4 4 0 0 1-4-4V21.493l1.86-4.005a2.667 2.667 0 0 1 2.418-1.544z'
                    strokeLinejoin='round'
                />
                <path
                    d='M23.37 29.114v4.416c0 4.337 3.149 7.852 7.033 7.852 3.884 0 7.032-3.515 7.032-7.852v-4.32'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path strokeLinejoin='round' d='M15.333 21.516h30.14' />
                <path
                    d='m47.884 9.525 1.403 2.395 2.776.017.017 2.776 2.395 1.403-1.373 2.412 1.373 2.412-2.395 1.403-.017 2.775-2.776.017-1.403 2.395-2.412-1.373-2.412 1.373-1.403-2.395-2.775-.017-.017-2.775-2.395-1.403 1.373-2.412-1.373-2.412 2.395-1.403.017-2.776 2.775-.017 1.403-2.395 2.412 1.373 2.412-1.373z'
                    fill='#00D1D2'
                />
            </g>
        </Icon>
    );
};

export default SpecialOffersIcon;
